import { sizes, spacing } from '@gitbook/react-uikit';

export const SPACE_HEADER_HEIGHT = sizes.L;

/** Max width of the page body (without padding) */
export const PAGE_BODY_MAX_WIDTH = 750;

/** Horizontal padding for the page body on desktop */
export const PAGE_BODY_DESKTOP_H_PADDING = 110;

/** Horizontal padding for the page body on desktop */
export const PAGE_BODY_MOBILE_H_PADDING = spacing.medium;

/** Width of the page body on desktop (with padding) */
export const PAGE_BODY_DESKTOP_WIDTH = PAGE_BODY_MAX_WIDTH + 2 * PAGE_BODY_DESKTOP_H_PADDING;

/** Width of the TOC on desktop */
export const TOC_DESKTOP_WIDTH = 300;

/** Width of comments column */
export const COMMENTS_COLUMN_EXPANDED_WIDTH = 300;

/** Width of the page outline */
export const PAGE_OUTLINE_WIDTH = 220;

/** Height of the header on public content */
export const PUBLIC_DESKTOP_HEADER_HEIGHT = sizes.XL;
export const PUBLIC_MOBILE_HEADER_HEIGHT = sizes.L;

/**
 * The threadhold until which we show a layout with the number of columns.
 *
 * You are supposed to use this function as keys for the `customBreakpointStyles`
 * prop of a Responsive Component.
 *
 * For example:
 *
 * ```tsx
 * <Responsive.View
*    mobileStyle={} // style shown on mobile
     customBreakpointStyles={{
         [columnsWidthThreadhold(2, sidebarWidth)]: {}, // style shown when we can only show a 2-columns layout
         [columnsWidthThreadhold(3, sidebarWidth)]: {}, // style shown when we can only show a 3-columns layout
     }}
     desktopStyle={} // style shown when can show a 4-columns layout
 * />
 * ```
 */
export function columnsWidthThreadhold(numberOfColumns: 2 | 3, sidebarWidth = 0) {
    let threadhold =
        sidebarWidth + TOC_DESKTOP_WIDTH + PAGE_BODY_DESKTOP_WIDTH + PAGE_OUTLINE_WIDTH;
    if (numberOfColumns === 2) {
        return threadhold;
    }
    threadhold += COMMENTS_COLUMN_EXPANDED_WIDTH - PAGE_BODY_MOBILE_H_PADDING;
    return threadhold;
}

/**
 * The threadhold until which we show the switches on top of each other instead of side by side.
 */
export function pageSwitchThreadhold(sidebarWidth = 0) {
    return sidebarWidth + PAGE_BODY_DESKTOP_WIDTH;
}
